module.exports = __webpack_public_path__ + "128ade72f8d6699ac74053528f08850e.jpg";